import type { FaireProductEntity } from "../../entity_types/product";

export const p_5enmjqqyp4: FaireProductEntity = {
  token: "p_5enmjqqyp4",
  type: "product",
  name: "Geode, Moroccan Sugar Geode",
  brandToken: "b_52zr2whq85",
  brandName: "Jensen Rocks",
  imageUrl:
    "https://cdn.faire.com/fastly/aa88d52efd61d1d38a6b1a32d961984906df8b52539330dc7d112c041d80eaec.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f6b0eea2077f5d25ae4aa9c81cc7c903680118a0d799b337eac0531cd9fc6814.jpeg",
    "https://cdn.faire.com/fastly/266f2c757badb283a6ff15f5b1e2917a7d16b4538fee33e25b0d251b391ceadc.jpeg",
  ],
  priceDollars: 20.79,
  description:
    'Our Sugar Geodes are all uniquely different. Each geode sparkles and contains quartz crystals, each with its own unique flair.\n\nAlso known as "whack & crack" geodes, no two stones crack the same way. Our pieces are pre-cracked and secured with rubber bands.\n\nPhotos accurately represent the product you will receive.\n\nSlight variations in color, size and natural formation are to be expected.\n\nSold as a set of 3 full Geodes.\n',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:19.192Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
